/**
 * Visual styling intent for the clickable.
 */
export enum EClickableVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DIMINUTIVE = 'diminutive',
}

/**
 * Controls the logical behavior and context of the clickable.
 *
 * - `cta` – Main call-to-action (default)
 * - `isolatedLink` – Used for basic links that need less visual weight
 * - `isolatedIcon` – Icon-only clickable (no label)
 * - `logo` – Clickable branding elements
 */
export enum EClickableTypes {
  CTA = 'cta',
  LINK = 'isolatedLink',
  ICON = 'isolatedIcon',
  LOGO = 'logo',
}

/**
 * Union type of all allowed clickable variants.
 * Used to restrict variant props to known values.
 */
export type TClickableVariants =
  | EClickableVariants.PRIMARY
  | EClickableVariants.SECONDARY
  | EClickableVariants.TERTIARY
  | EClickableVariants.DIMINUTIVE;

/**
 * Defines size options for a clickable.
 *
 * - `sm` – Small (compact spacing)
 * - `lg` – Large (more padding, common for CTAs)
 */
export enum EClickableSize {
  SM = 'sm',
  LG = 'lg',
}

/**
 * Union type of all allowed clickable sizes.
 */
export type TClickableSize = EClickableSize.SM | EClickableSize.LG;

/**
 * Determines link target behavior.
 *
 * - `_blank` – Opens in a new tab
 * - `_self` – Opens in the same tab (default behavior)
 */
export enum EClickableTarget {
  BLANK = '_blank',
  SELF = '_self',
}

/**
 * Defines where the icon should appear relative to the label.
 *
 * - `left` – Icon appears before the label
 * - `right` – Icon appears after the label
 * - `none` – No icon
 */
export type TClickableIconPosition = 'left' | 'right' | 'none';
